export const MERGE_SITE_TOOL_TITLE = 'Merge Sites'
export const TOOL_DESCRIPTION = `This tool merges users and licenses from a "Duplicate Site" to a "Primary Site." Once processed, the change is permanent and cannot be reversed.`

export const MERGE_TOOL_RULES_TITLE = "Merge Rules"

export const MERGE_TOOL_RULES_FAMILY_ACCESS = "If either site has Family Access codes, the merged site will retain those codes."
export const MERGE_TOOL_RULES_LICENSES = "All licenses will be added to the Primary Site even if the Primary Site already has the same program. Review Merge Sites Outcome before submitting merge request."
export const MERGE_TOOL_RULES_PREFERENCES = "All Preference and Pacing configuration will remain unchanged on the primary site."
export const MERGE_TOOL_RULES_ROSTERING = "If either site is rostered, the merged site will be rostered."
export const MERGE_TOOL_RULES_USERS =  "Duplicate Site users will be added to the Primary Site. Users who have different roles at each site will retain the highest-level role post merge."


// WEBPACK FOOTER //
// ./src/containers/css-admin/mergeSite/constants.js